import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ORG_APPLY_URL, ORG_APPLY_HELPER_COPY } from "@/lib/organisationSignup";
import FormitiTrustBlock from "@/components/FormitiTrustBlock";

const Footer = () => {
  useEffect(() => {
    if (document.getElementById("sf-badge-script")) return;
    const sc = document.createElement("script");
    sc.id = "sf-badge-script";
    sc.async = true;
    sc.src = "https://b.sf-syn.com/badge_js?sf_id=3410631&variant_id=sf";
    document.body.appendChild(sc);
  }, []);

  return (
  <footer className="border-t border-border/60 bg-foreground text-background">
    <div className="container py-16">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2 font-semibold text-lg mb-4">
            <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
              <span className="text-primary-foreground text-sm font-bold">P</span>
            </div>
            Privacy360
          </Link>
          <p className="text-sm opacity-60 leading-relaxed">
            One operational platform for privacy, AI governance and trust.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-sm mb-4 opacity-80">Platform</h4>
          <ul className="space-y-2.5 text-sm opacity-60">
            <li><Link to="/platform/" className="hover:opacity-100 transition-opacity">Overview</Link></li>
            <li><Link to="/ai-governance/" className="hover:opacity-100 transition-opacity">AI Governance</Link></li>
            <li><Link to="/modules/" className="hover:opacity-100 transition-opacity">Modules</Link></li>
            <li><Link to="/pricing/" className="hover:opacity-100 transition-opacity">Pricing</Link></li>
            <li><Link to="/data-residency/" className="hover:opacity-100 transition-opacity">Data Residency</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-sm mb-4 opacity-80">Company</h4>
          <ul className="space-y-2.5 text-sm opacity-60">
            <li><Link to="/about/" className="hover:opacity-100 transition-opacity">About</Link></li>
            <li><Link to="/contact/" className="hover:opacity-100 transition-opacity">Contact</Link></li>
            <li><Link to="/blog/" className="hover:opacity-100 transition-opacity">Blog</Link></li>
            <li><Link to="/toolkits/" className="hover:opacity-100 transition-opacity">Toolkits</Link></li>
            <li><Link to="/compare/" className="hover:opacity-100 transition-opacity">Compare</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-sm mb-4 opacity-80">Get Started</h4>
          <ul className="space-y-2.5 text-sm opacity-60">
            <li><Link to="/book-demo/" className="hover:opacity-100 transition-opacity">Book Demo</Link></li>
            <li><a href={ORG_APPLY_URL} className="hover:opacity-100 transition-opacity">Apply for an account</a></li>
          </ul>
        </div>
      </div>

      <FormitiTrustBlock />

      <div className="border-t border-background/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <p className="text-xs opacity-80">© {new Date().getFullYear()} Formiti Data International. All rights reserved.</p>
          <div
            className="sf-root opacity-50 hover:opacity-80 transition-opacity"
            data-id="3410631"
            data-badge="light-default"
            data-variant-id="sf"
            style={{ width: 80 }}
          >
            <a href="https://sourceforge.net/software/product/Privacy360/" target="_blank" rel="noopener noreferrer">
              Privacy360 Reviews
            </a>
          </div>
        </div>
        <div className="flex gap-6 text-xs opacity-80">
          <Link to="/privacy-policy/" className="hover:opacity-100 transition-opacity">Privacy Notice</Link>
          <Link to="/terms-and-conditions/" className="hover:opacity-100 transition-opacity">Terms &amp; Conditions</Link>
          <Link to="/ai-terms-addendum/" className="hover:opacity-100 transition-opacity">AI Terms Addendum</Link>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
